import { usePayrollRoster } from "@/payroll/roster/query";
import { isPayrollAccessError } from "./access-error";
import { useTeamSelection } from "./use-team-selection";

/** Team choices are supplied by the API for the current viewer. */
export const useTeamFilter = (businessId: string | null) => {
  const query = usePayrollRoster(businessId);
  const teams = query.isSuccess ? (query.data?.available_teams ?? []) : [];
  const temporarilyUnavailable =
    query.isError && !isPayrollAccessError(query.error);
  const selection = useTeamSelection(
    businessId,
    temporarilyUnavailable ? null : teams,
  );
  return { teams, ...selection };
};
